import request from './request'
import Vue from 'vue'
import axios from 'axios'

let Http = {
    postData (requestUrl, params) {
        var baseUrl = null
        // if("development"!=process.env.NODE_ENV) {
        //     baseUrl = process.env.api
        //     requestUrl = this.replaceUrl(requestUrl)
        // }
        var user = localStorage.getItem('user')
        if (user) {
            var u = JSON.parse(user)
            params.token = u.token
        }
        return request({
            baseURL: baseUrl,
            url: requestUrl,
            method: 'post',
            data: params
        })
    },
    downloadFile (requestUrl, filename, callback, method, data) {
        if (!method) {
            method = 'get'
        }
        axios({
            url: requestUrl,
            method: method,
            data: data,
            // headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded'
            // },
            responseType: 'blob'
        }).then(res => {
            if (res.headers['content-type'] === 'application/json;charset=UTF-8') {
                let reader = new FileReader()
                reader.readAsText(res.data, 'utf-8')
                reader.onload = e => {
                    let readerres = reader.result
                    let parseObj = {}
                    parseObj = JSON.parse(readerres)
                    Vue.prototype.$alert(parseObj.desc)
                }
                // Vue.prototype.$alert('下载出现错误')
                return
            }
            let blob = new Blob([res.data], { type: 'application/octet-stream' })
            let href = window.URL.createObjectURL(blob)
            // 兼容 ie
            if (window.navigator.msSaveBlob) {
            //   window.navigator.msSaveBlob(blob, i.name)
            } else {
              const link = document.createElement('a')
              link.style.display = 'none'
              link.href = href
              link.download = filename
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              window.URL.revokeObjectURL(link)
            }
            if (callback) {
                console.log('download success')
                callback.call(this)
            }
          })
        // return request({
        //     // baseURL: baseUrl,
        //     url: requestUrl,
        //     method: 'get',
        //     responseType: 'blob'
        // })
    },
    doDownload (data, filename) {
        if (!data) {
            return
        }
        let url = window.URL.createObjectURL(new Blob([data], { type: 'application/octet-stream' }))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
    },
    previewFile (requestUrl) {
        return axios({
            method: 'get',
            responseType: 'blob', // 设置响应文件格式
            url: requestUrl
        })
    }
}
export default Http



// WEBPACK FOOTER //
// ./src/util/http.js